// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d47efc1e","31":"f37bd2a6","57":"7a05ceac","210":"9a91714c","213":"3fc68f03","284":"23ca56d0","351":"2d0f6c18","453":"d477290f","598":"381769ed","974":"aa47ae24"}[chunkId] + ".chunk.js";
};